function PendingJobsCtrl($state, $stateParams, toaster, PendingJobsService, CommonService, AppSettings) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.pendingJobs = [];
  vm.rowPerPageOptions = ['50','100','200'];
  vm.pageNumber = $stateParams.page ? $stateParams.page : 1;
  vm.size = $stateParams.size ? $stateParams.size : "50";
  vm.loading = false;
  vm.flag = false;

  vm.init = function() {
   let url = `/organizations/${$stateParams.orgId}/background_jobs.json?page=${vm.pageNumber}&size=${vm.size}`;
    vm.loading = true;
    PendingJobsService.listPendingJobs(url,function(response) {
      if(response.status == 200) {
        vm.pendingJobs = response.data;
        vm.loading = false;
        }
      });
    };

  vm.paginate = function (param) {
    let url = vm.pendingJobs.links[param];
    if(url) {
      var arr = url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', url);
      $state.go($state.current.name,{page: vm.pageNumber,size: vm.size});
    }
  };

  vm.deletePending = function(job) {
    if(!vm.isBulkType(job)){
  swal({
      title: "Are you sure you want to delete this pending job?",
      text: "All the information related with this will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
  })
  .then(willDelete => {
    if (willDelete) {
      PendingJobsService.delete($stateParams.orgId,job.id, function(response){
        if(response.status == 204) {
          vm.removePending(job.id);
          toaster.pop('info', 'Pending job deleted');
        }
      });
    }
  });
}
}

vm.removePending = function(background_jobs_id){
    for(var i = vm.pendingJobs.background_jobs.length - 1; i >= 0; i--){
      if(vm.pendingJobs.background_jobs[i].id == background_jobs_id){
         vm.init();
      }
    }
  };
vm.isBulkType = function(job){
  return job.name_humanize.indexOf('bulk cost') != -1 || job.name_humanize.indexOf('amazon payout') != -1;
  }
}



export default {
  name: 'PendingJobsCtrl',
  fn: PendingJobsCtrl
};
